<template>
  <div class="report full-vh">
    <a-row>
      <div class="card-container">
        <a-tabs type="card">
          <a-tab-pane key="tmsReport" tab="TMS Report" class="bg-white p35">
            <a-row type="flex" class="report-items">
              <a-col :lg="3" :md="4">
                <router-link to="/report/detail">
                  <a-card class="bg-gray report-card-item" size="small" hoverable>
                    <img slot="cover" alt="example" src="../../assets/images/detail-report-icon.png" />
                    <a-card-meta>
                      <template slot="title">
                        <a>Timesheets Details</a>
                      </template>
                    </a-card-meta>
                  </a-card>
                </router-link>
              </a-col>
              <a-col :lg="3" :md="4">
                <router-link to="/report/summary">
                  <a-card class="bg-gray report-card-item" size="small" hoverable>
                    <img slot="cover" alt="example" src="../../assets/images/summary-report-icon.png" />
                    <a-card-meta>
                      <template slot="title">
                        <a>Timesheets Summary</a>
                      </template>
                    </a-card-meta>
                  </a-card>
                </router-link>
              </a-col>
              <a-col :lg="3" :md="4">
                <router-link to="/report/checkTime">
                  <a-card class="bg-gray report-card-item" size="small" hoverable>
                    <img slot="cover" alt="example" src="../../assets/images/checkIO-icon.png" />
                    <a-card-meta>
                      <template slot="title">
                        <a>Check in - Check out</a>
                      </template>
                    </a-card-meta>
                  </a-card>
                </router-link>
              </a-col>
              <a-col :lg="3" :md="4">
                <router-link to="/report/policy-mapping">
                  <a-card class="bg-gray report-card-item" size="small" hoverable>
                    <img slot="cover" alt="example" src="../../assets/images/summary-report-icon.png" />
                    <a-card-meta>
                      <template slot="title">
                        <a>Work Schedule Report</a>
                      </template>
                    </a-card-meta>
                  </a-card>
                </router-link>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane key="payrollReport" tab="Payroll Report" class="bg-white p15">
            <div class="mr10" style="margin: 0 auto">
              <a-table>
                <a slot="name" slot-scope="text">{{ text }}</a>
                <span slot="name" slot-scope="text, record">
                  <a-row>
                    <a-col :span="8">
                      <a-avatar icon="user" />
                    </a-col>
                    <a-col :span="16">
                      <div>{{ record.name }}</div>
                      <div>{{ text }}</div>
                    </a-col>
                  </a-row>
                </span>
                <span slot="status">
                  <div class="text-center text-bold p5">Approved</div>
                </span>
                <span slot="action">
                  <div>
                    <a-row type="display">
                      <span class="mr5">
                        <a-button type="primary" ghost>Approve</a-button>
                      </span>
                      <span>
                        <a-button type="primary" ghost>Reject</a-button>
                      </span>
                    </a-row>
                  </div>
                </span>
                <Table {{customRow(record)}} />
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-row>
  </div>
</template>

<script>
import { scaleScreen } from "../../components/commons/commons";
export default {
  name: "Report",
  props: {
    msg: String,
  },
  created() {
    this.scaleScreen();
  },
  methods: {
    scaleScreen,
  },
};
</script>
<style></style>
